import { render, staticRenderFns } from "./PDA_Management.vue?vue&type=template&id=9a7ecc36"
import script from "./PDA_Management.vue?vue&type=script&lang=js"
export * from "./PDA_Management.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports